/** Preset display currencies in the site header. Any valid ISO 4217 code may be set programmatically (e.g. from API). */
export const MONEY_DISPLAY_PRESET_CODES = ["AZN", "EUR", "RUB"] as const;
export type MoneyDisplayPresetCode = (typeof MONEY_DISPLAY_PRESET_CODES)[number];

export function isIso4217Code(raw: string): boolean {
    const u = raw?.trim().toUpperCase() ?? "";
    return /^[A-Z]{3}$/.test(u);
}

/** Returns uppercase ISO code or `null` if invalid. */
export function normalizeMoneyCurrencyCode(
    raw: string | undefined,
): string | null {
    if (!raw?.trim()) return null;
    const u = raw.trim().toUpperCase();
    return isIso4217Code(u) ? u : null;
}
